import { Outlet, useLocation } from 'react-router-dom';
import { TopBar } from './TopBar';
import { SideNav } from './SideNav';
import { ErrorBoundary } from './ErrorBoundary';
import { CommandPalette } from './CommandPalette';
import { RouteTitle } from './RouteTitle';
import { TradeLockedBanner } from '@/components/widgets/TradeLockedBanner';
import {
  ForceLiquidateButton,
  ForceLiquidateDialogs,
  LiquidationOverlay,
} from '@/features/force-liquidate';
import { AlertsBootstrap } from '@/features/alerts/AlertsBootstrap';

/**
 * 全局壳:TopBar + 告示条 + 侧栏 + 主区。
 * 移动端浮动 FAB(强平按钮)固定在右下,符合 §8.4.6 "移动端响应式布局也保留此按钮"。
 * 强平 2 步弹窗 + 进度遮罩 + AlertsBootstrap 挂在最外层,任意页面都能触发/订阅。
 * 主区用 ErrorBoundary 包裹,任意 page 抛错时降级展示 + 路由切换自动重置。
 */
export function AppLayout() {
  const location = useLocation();
  return (
    <div className="flex h-screen flex-col">
      <TopBar />
      <TradeLockedBanner />
      <div className="flex flex-1 overflow-hidden">
        <SideNav />
        <main className="flex-1 overflow-y-auto scrollbar-thin">
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <ForceLiquidateButton variant="fab" />
      <ForceLiquidateDialogs />
      <LiquidationOverlay />
      <AlertsBootstrap />
      <CommandPalette />
      <RouteTitle />
    </div>
  );
}
